'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('settings-edit', {
      url: '/admin/settings/edit/:id',
      template: '<settings-edit></settings-edit>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/settings-edit/settings-edit.routes.js